<template>
  <div class="shaij-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brand" @change="setBid" style="width: 120px" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.bid" :label="brand.name" :value="brand.bid" />
              </el-select>
            </el-form-item>
            <el-form-item label="风格">
              <el-select v-model="searchForm.style" style="width: 120px" placeholder="请先选择品牌" filterable clearable>
                <el-option v-for="style in searchStyleList" :key="style.sid" :label="style.name" :value="style.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="面积">
              <el-select v-model="searchForm.area" style="width: 120px" filterable clearable>
                <el-option v-for="area in areaList" :key="area.aid" :label="area.name" :value="area.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="居室">
              <el-select v-model="searchForm.room" style="width: 120px" filterable clearable>
                <el-option v-for="room in bedRoomList" :key="room.bid" :label="room.name" :value="room.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="addTemplate">添加晒家</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="showHomeList"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    label="封面图"
                    width="100"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-image
                        :src="scope.row.imgUrl"
                        fit="cover"
                        style="height: 40px;"
                        :preview-src-list="[scope.row.imgUrl]"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    label="标题"
                    width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="描述"
                    min-width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.delid === '0' ">公共</span>
                      <span v-if="scope.row.delid !== '0' ">{{scope.row.delidName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    label="品牌"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="style"
                    label="风格"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="room"
                    label="居室"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="area"
                    label="面积"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="amount"
                    label="总费用"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="views"
                    label="浏览量"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="username"
                    label="上传人"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    label="发布时间"
                    width="200"
                    align="center"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="200"
                    align="center"
                    fixed="right">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" size="mini" @click="editTemplate(scope.row)">修改</el-button>
                      <el-button icon="el-icon-delete" size="mini" @click="deleteTemplate(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="封面图" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传750*280尺寸的图片</span>
          <SingleImg :key="imgKey" v-model="addForm.img" :oldurl="addForm.oldimgurl" :size="[375,140]" />
        </el-form-item>
        <el-row>
          <el-col :span="6">
            <el-form-item label="品牌" prop="brand">
              <el-select v-model="addForm.brand" @change="setEditBid" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.bid" :label="brand.name" :value="brand.bid" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="风格" prop="style">
              <el-select v-model="addForm.style" placeholder="请先选择品牌" filterable clearable>
                <el-option v-for="style in editStyleList" :key="style.sid" :label="style.name" :value="style.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="面积" prop="area">
              <el-select v-model="addForm.area" filterable clearable>
                <el-option v-for="area in areaList" :key="area.aid" :label="area.name" :value="area.name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="居室" prop="room">
              <el-select v-model="addForm.room" filterable clearable>
                <el-option v-for="room in bedRoomList" :key="room.bid" :label="room.name" :value="room.name" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" maxlength="300" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input
            v-model="addForm.remark"
            maxlength="500"
            type="textarea"
            :rows="3"
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-row>
          <el-col :span="6">
            <el-form-item label="总费用" prop="amount">
              <el-input v-model="addForm.amount" maxlength="20" show-word-limit >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="浏览量" prop="views">
              <el-input-number v-model="addForm.views" :precision="0" :min="1" :max="1000000" show-word-limit>
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="详情" prop="content">
          <Tinymce v-model="addForm.content" v-if="dialogVisible"></Tinymce>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="btnLoading" @click="submitTemplate">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce/index'
import { getUser } from '@/utils/auth'
import { addOrEditShowHome, delShowHome, getAreaList, getBedRoomList, getBrand, getShowHomeList } from '@/api/community'
import { getWxStyleList } from '@/api/pub'
import SingleImg from '@/components/upload/SingleImg'

export default {
  name: 'sj',
  computed: {
    user: getUser
  },
  components: {
    SingleImg,
    Tinymce
  },
  data() {
    return {
      imgKey: '',
      loading: false,
      remarkVisible: false,
      dialogTitle: '',
      dialogVisible: false,
      btnLoading: false,
      brandList: [],
      styleList: [],
      searchStyleList: [],
      editStyleList: [],
      areaList: [],
      bedRoomList: [],
      searchForm: {
        brand: null,
        style: '',
        area: '',
        room: '',
        search: ''
      },
      showHomeList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      addForm: {
        img: null,
        delid: '0',
        oldimgurl: '',
        brand: null,
        style: '',
        room: '',
        area: '',
        title: '',
        remark: '',
        amount: '',
        content: '',
        views: null,
        id: 0
      },
      addRules: {
        brand: [{ required: true, message: '请选择品牌', trigger: 'change' }],
        style: [{ required: true, message: '请选择风格', trigger: 'change' }],
        area: [{ required: true, message: '请选择面积', trigger: 'change' }],
        room: [{ required: true, message: '请选择居室', trigger: 'change' }],
        remark: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入总费用', trigger: 'blur' }],
        img: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        content: [{ required: true, message: '请输入文本', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        views: [{ required: true, message: '请输入浏览量', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getData()
    this.getBrandList()
    this.getAreaList()
    this.getStyleList()
    this.getBedRoomList()
  },
  methods: {
    setBid(v) {
      this.searchStyleList = []
      let _searchStyleList = []
      for (const s of this.styleList) {
        if (s.bid === v) {
          _searchStyleList.push(s)
        }
      }
      this.searchStyleList = _searchStyleList
      this.searchForm.style = ''
    },
    setEditBid(v) {
      this.editStyleList = []
      let _editStyleList = []
      for (const s of this.styleList) {
        if (s.bid === v) {
          _editStyleList.push(s)
        }
      }
      this.editStyleList = _editStyleList
      this.addForm.style = ''
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        brand: this.searchForm.brand,
        area: this.searchForm.area,
        style: this.searchForm.style,
        room: this.searchForm.room,
        search: this.searchForm.search,
        groupid: this.user.dGroupid
      }
      getShowHomeList(data).then(response => {
        this.showHomeList = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getBrandList() {
      getBrand().then(response => {
        let _brandList = []
        if (this.user.dGroupid === 1) { // 杭州乔金斯
          for (const b of response.data) {
            if (b.bid === 3) {
              _brandList.push(b)
            }
          }
        } else if (this.user.dGroupid === 2) { // 耐思迪
          for (const b of response.data) {
            if (b.bid === 1 || b.bid === 2) {
              _brandList.push(b)
            }
          }
        }
        this.brandList = _brandList
      })
    },
    getAreaList() {
      getAreaList().then(response => {
        this.areaList = response.data
      })
    },
    getStyleList() {
      getWxStyleList({}).then(response => {
        this.styleList = response.data
      })
    },
    getBedRoomList() {
      getBedRoomList().then(response => {
        this.bedRoomList = response.data
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    addTemplate() {
      this.addForm.area = ''
      this.addForm.brand = null
      this.addForm.room = ''
      this.addForm.style = ''
      this.addForm.title = ''
      this.addForm.remark = ''
      this.addForm.amount = ''
      this.addForm.delid = '0'
      this.addForm.views = null
      this.addForm.img = null
      this.addForm.oldimgurl = null
      this.addForm.content = ''
      if (this.user.rank === 0) {
        this.addForm.role = 2
      } else if (this.user.rank === 1) {
        this.addForm.role = 1
      } else {
        this.addForm.role = 0
      }
      this.dialogTitle = '添加晒家'
      this.addForm.id = 0
      this.dialogVisible = true
      this.imgKey = new Date().getTime().toString()
    },
    editTemplate(row) {
      this.imgKey = new Date().getTime().toString()
      this.addForm.id = row.shid
      this.addForm.area = row.area
      this.addForm.delid = row.delid
      this.addForm.brand = row.brand
      this.setEditBid(row.brand)
      this.addForm.room = row.room
      this.addForm.style = row.style
      this.addForm.title = row.title
      this.addForm.remark = row.remark
      this.addForm.amount = row.amount
      this.addForm.views = row.views
      this.addForm.img = { imgid: row.imgid, imgUrl: row.imgUrl }
      this.addForm.oldimgurl = row.imgUrl
      this.addForm.content = row.content
      this.addForm.role = row.role
      this.dialogTitle = '修改晒家'
      this.dialogVisible = true
    },
    deleteTemplate(row) {
      this.$confirm('您确定要删除此晒家吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delShowHome({ id: row.shid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    submitTemplate() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            const data = {
              id: this.addForm.id,
              delid: this.addForm.delid,
              area: this.addForm.area,
              brand: this.addForm.brand,
              room: this.addForm.room,
              style: this.addForm.style,
              title: this.addForm.title,
              remark: this.addForm.remark,
              amount: this.addForm.amount,
              views: this.addForm.views,
              imgid: this.addForm.img.imgid,
              content: this.addForm.content,
              role: this.addForm.role,
              userid: this.user.dUserid
            }
            addOrEditShowHome(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.shaij-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409EFF;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 178px;
          height: 178px;
          line-height: 178px;
          text-align: center;
        }
        .avatar {
          width: 178px;
          height: 178px;
          display: block;
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
